module.exports = __webpack_public_path__ + "img/error_404bg-m.b488d61.jpg";